export default __webpack_public_path__ + "static/media/email_icon_white_bordered.0631da16.svg";